import React from 'react'
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"


export default function MansoryLayout({ children, className}) {
  return (
    <ResponsiveMasonry
      columnsCountBreakPoints={{350: 1, 750: 2, 900: 4}}
    >
        <Masonry className={className}>
          {children}
        </Masonry>
    </ResponsiveMasonry>
  )
}
